import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=055e83bf&"
import script from "./Overlay.vue?vue&type=script&lang=ts&"
export * from "./Overlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports